/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIls = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 2c3.86 0 7 3.141 7 7v6h-2V9c0-2.757-2.243-5-5-5H5v18H3V2zm12 0v20h-6c-3.86 0-7-3.141-7-7V9h2v6c0 2.757 2.243 5 5 5h4V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIls as Ils };
